import axiosInstance from "@/api/axios-instance";

export async function getActiveBundles(regionId?: string) {
  // NOTE: silent cap — if active bundles ever exceed 100, the dropdown (and
  // its "Select All") truncates with no indication. The proper fix is a
  // searchable/paginated picker; revisit when the catalog approaches the cap.
  //
  // region_id scopes the list server-side via the Bundle→Region relation —
  // the canonical filter. (The legacy Bundle.region string drifted from
  // Region.code — 'uae' vs 'ae' — so never compare those client-side.)
  const params = new URLSearchParams({ limit: "100" });
  if (regionId) params.set("region_id", regionId);
  const response = await axiosInstance.get(`/bundle/active?${params}`);

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to fetch active bundles");
  }

  return response.data;
}
